import PanelRight from "./SVG/panel-right.svg?react";

const PanelRightIcon = () => {
  return <PanelRight />;
};

export default PanelRightIcon;
